import { render, staticRenderFns } from "./Orderdz.vue?vue&type=template&id=02dcf651&scoped=true"
import script from "./Orderdz.vue?vue&type=script&lang=js"
export * from "./Orderdz.vue?vue&type=script&lang=js"
import style0 from "./Orderdz.vue?vue&type=style&index=0&id=02dcf651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dcf651",
  null
  
)

export default component.exports